module.exports = __webpack_public_path__ + "media/apartment.5f7a6327.svg";